<template>
  <section class="page_topline ds c-my-10 s-py-5">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-xl-12 text-center text-lg-right">
          <ul class="top-includes border-divided small-text">
            <router-link tag="li" to="/">
              <span>
                <a>{{ $t('inicio') }}</a>
              </span>
            </router-link>

            <router-link tag="li" to="/signup" v-if="!status.loggedIn">
              <span>
                <a>{{ $t('registro') }}</a>
              </span>
            </router-link>

            <router-link tag="li" to="/user" v-if="status.loggedIn">
              <span>
                <a>
                  <i class="fa fa-user"></i>
                  {{ $t('mi perfil') }}&nbsp;<span style="font-size:0.7em;">({{ user.email }})</span>
                </a>
              </span>
            </router-link>

     <!--        <li>
              <span>
                <a href="#">
                  <i class="fa fa-lock"></i> {{ $t('inscripciones') }}
                </a>
              </span>
            </li> -->

     <!--        <li>
              <span class="social-icons">
                <a href="#" class="fa fa-facebook" title="facebook"></a>
              </span>
            </li> -->
            <!-- componente de idioma -->
            <Lang></Lang>

            <!-- salir si la sesión está iniciada -->
            <li v-if="status.loggedIn">
              <a href="#" v-on:click="logout">{{ $t('cerrar sesion') }}</a>
            </li>

            <!-- link que dirige a user para hacer login siempre que no estemos logeados -->
            <router-link tag="li" to="/user" v-if="!status.loggedIn">
              <span>
                <a>
                  <i class="fa fa-user"></i>
                  {{ $t('iniciar sesion') }}
                </a>
              </span>
            </router-link>


          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Lang from "@/components/layouts/Lang.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Lang
  },
  computed: {
    ...mapState("account", ["status", "user"])
  },
  methods:{
    ...mapActions("account", ["logout"])
  } 
};
</script>
